export default __webpack_public_path__ + "static/media/note.187c7d4c.png";